export default __webpack_public_path__ + "096455496c10e245a8a186cf53c44935.svg";